export default "__VITE_ASSET__BUCvP1Ow__"